import React from 'react';
import { Segment, Grid, Image } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import corunaImage from '../../assets/img/corunaImage.png';
import mici from '../../assets/img/micin-uefeder-aei.png';
import XuntaImage from '../../assets/img/XuntaImage.png';

const Footer = () => (
  <div className="footer">
    <Segment attached>
      <Grid divided='vertically'>
        <Grid.Row columns={3} verticalAlign='middle'>
          <Grid.Column>        
            <Image src={mici} size='medium' centered  />        
          </Grid.Column>
          <Grid.Column>        
            <Image src={corunaImage} size='medium' centered  />        
          </Grid.Column>
          <Grid.Column>        
            <Image src={XuntaImage} size='small' centered  />        
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment>
  </div>
);

export default Footer;
